import { css } from 'styled-components';

export const borderRadiusSize = '6px';

export const borderRadius = () => css`
  border-radius: ${borderRadiusSize};
  overflow: hidden;
`;
